export default "__VITE_ASSET__CRfgcsBJ__"